export enum SidebarViewType {
  KNOWLEDGE_EDITOR = 'knowledge_editor',
  INSTANT_ANSWERS = 'instant_answers',
  POSITIVE_COMMENT_REPLIES = 'positive_comment_replies',
  TOV_SETUP = 'tov_setup',
  AUTOMATION_READY_ROUTER = 'automation_ready_router',
  ENGAGEMENT_GOAL_EDITOR = 'engagement_goal_editor',
  KNOWLEDGE_ADDED = 'knowledge_added',
  GOAL_TYPE_PICKER = 'goal_type_picker',
  KNOWLEDGE_ENTRY_TYPE_PICKER = 'knowledge_entry_type_picker',
}

export const SIDEBAR_VIEW_TYPES_LIST = [
  SidebarViewType.KNOWLEDGE_EDITOR,
  SidebarViewType.INSTANT_ANSWERS,
  SidebarViewType.POSITIVE_COMMENT_REPLIES,
  SidebarViewType.TOV_SETUP,
  SidebarViewType.AUTOMATION_READY_ROUTER,
  SidebarViewType.ENGAGEMENT_GOAL_EDITOR,
  SidebarViewType.KNOWLEDGE_ADDED,
  SidebarViewType.GOAL_TYPE_PICKER,
  SidebarViewType.KNOWLEDGE_ENTRY_TYPE_PICKER,
]
